export enum WorkerRole {
  OWNER = "OWNER",
  EMPLOYEE = "EMPLOYEE",
}
